const LoadingActions = {
    UPDATE: 'UPDATE_LOADING',
}

export default LoadingActions;